import { z } from 'zod';

/**
 * Ghost text experiment cohort enum
 */
export enum GhostTextExperimentCohort {
	CONTROL = 'control',
	THREE_P = '3p',
}

/**
 * Number of times to show each text before rotating to the next
 */
export const ROTATION_THRESHOLD = 3;

/**
 * Ghost text data schema for QuickFind search input placeholder.
 * Used to persist and restore dynamic placeholder text across sessions.
 */
export const ghostTextDataSchema = z.object({
	/** The placeholder text to display */
	text: z.string(),
	/** Category/context for the ghost text */
	category: z.nativeEnum(GhostTextExperimentCohort),
	/** Number of times this text has been shown (0-2, resets after 3) */
	occurrence: z.number().optional().default(0),
});

export type GhostTextData = z.infer<typeof ghostTextDataSchema>;

/**
 * Parses a JSON string into ghost text data.
 * Returns undefined if parsing fails or data is invalid.
 *
 * @param json - The JSON string to parse
 * @returns GhostTextData object or undefined if invalid
 */
export const parseGhostText = (json: string): GhostTextData | undefined => {
	if (!json) {
		return undefined;
	}

	try {
		const result = ghostTextDataSchema.safeParse(JSON.parse(json));
		if (result.success) {
			return result.data;
		}

		return undefined;
	} catch {
		return undefined;
	}
};
